var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgBloodPressureDefault = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  "aria-hidden": true,
  viewBox: "0 0 16 15",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.328 1.011C12.515-.52 9.733-.3 8.014 1.481 6.264-.302 3.48-.52 1.668 1.01c-2.344 1.97-2 5.19-.312 6.908l5.47 5.595c.312.313.719.5 1.188.5.437 0 .844-.187 1.156-.5l5.502-5.595c1.656-1.719 2-4.938-.344-6.908m-.75 5.846-5.47 5.595c-.063.062-.126.062-.22 0l-5.47-5.595c-1.156-1.157-1.375-3.345.22-4.69 1.218-1.03 3.094-.874 4.282.314l1.094 1.125L9.108 2.48c1.156-1.188 3.032-1.345 4.25-.344 1.595 1.375 1.376 3.563.22 4.72"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBloodPressureDefault);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;